import { CellRenderType } from '/@/modules/core/table/constants/TableConstant';
import BaseCellRender from './BaseCellRender';

class CustomCellRender extends BaseCellRender {
  constructor() {
    super(CellRenderType.CUSTOM);
  }
}

export default CustomCellRender;
